
  import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import EarthIcon from "@/components/Icons/EarthIcon.vue";

  @Component({
    components: {
      EarthIcon,
    }
  })
  export default class PurchaseAgreementModal extends Vue {
    @Prop({ required: true, default: false }) public readonly modalShow!: boolean;
   
    public isModalClosed: boolean = false;
    public offerHtml: string = '';
    public loading: boolean = false;

    // Methods
    public closeModal() {
      this.isModalClosed = true;
      this.$emit("close-modal");
    }

    public async loadOffer() {
      this.loading = true;
      const lang = this.$root.$i18n.locale === 'ru' ? 'ru' : 'en';
      try {
        const res = await fetch(`/offers/offer-${lang}.html`);
        this.offerHtml = await res.text();
      } catch (error) {
        console.error('Error loading offer:', error);
        this.offerHtml = '';
      } finally {
        this.loading = false;
      }
    }

    // Загружай при открытии модалки
    @Watch('modalShow', { immediate: true })
    onModalShowChange(newVal: boolean) {
      if (newVal) {
        this.loadOffer();
      }
    }
  }
  